"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useTracker = _interopRequireDefault(require("./useTracker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tracker = function Tracker() {
  (0, _useTracker.default)();
  return null;
};

var _default = Tracker;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUcmFja2VyIiwidXNlVHJhY2tlciJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL1RyYWNrZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVRyYWNrZXIgZnJvbSAnLi91c2VUcmFja2VyJztcblxuY29uc3QgVHJhY2tlcjogUmVhY3QuRkM8e30+ID0gKCkgPT4ge1xuICB1c2VUcmFja2VyKCk7XG5cbiAgcmV0dXJuIG51bGw7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBUcmFja2VyO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQSxJQUFNQSxPQUFxQixHQUFHLFNBQXhCQSxPQUF3QixHQUFNO0VBQ2xDLElBQUFDLG1CQUFBO0VBRUEsT0FBTyxJQUFQO0FBQ0QsQ0FKRDs7ZUFNZUQsTyJ9